import CartLayoutTemplate from './CartLayoutTemplate'

export default CartLayoutTemplate
// eslint-disable-next-line import/export
export * from './CartLayoutTemplate'
